<script>
    /*
    	ListHeader.svelte

        Accepts a headerCells object which defines the cells across the Header.

        const cells = [
            {type: CELL_CHECKBOX, label: null, align: null, width: '5%', propName: null},
            {type: CELL_SORTABLE, label: 'Name', align: 'left', width: '25%', propName: 'service-name'},
            {type: CELL_SORTABLE, label: 'Distance', align: 'left', width: '10%', propName: 'service-distance'}
        ]

        <ListHeaderCell> props:

            export let type;            // cheating - which comp to generate - see below
            export let label;           // caption in Header
            export let align;           // text-align of label 'left'
            export let width;           // % of width in Header '25%'
            export let propName;        // which field in the dataset
            export let onSort;          // external sort function for CELL_SORTABLE

    */

    import { onMount } from 'svelte';

    // TCARE components
	import ListHeaderCell from './ListHeaderCell.svelte';

    // SMUI components

    export let headerCells;


    onMount(() => {
    })


</script>

<style>

    .list-header {
        width: 100%;
        padding: 10px 0px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background-color: var(--tcare-purple);
        border-radius: 8px;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="list-header">
    {#each headerCells as cell}
        <ListHeaderCell 
            type={cell.type}
            label={cell.label}
            propName={cell.propName}
            onSort={cell.onSort}
            align={cell.align}
            style={cell.style}
            onCheckboxClick={cell.onCheckboxClick}
        />
    {/each}
</div>

